// extracted by mini-css-extract-plugin
module.exports = {"main":"DeviceSettingOption_main__8vYnc","btn":"DeviceSettingOption_btn__31Zjz"};